module.exports = __webpack_public_path__ + "files/5769fab56a62c5072422a3217a4a655f.png";